import React, { useRef, useState } from 'react'
import { Button, Col, Overlay, Popover, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import Datetime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'

// Formats a startOn/endOn param (a moment object from react-datetime, or a
// raw string before it parses) into MM/DD/YYYY for the trigger label.
const formatValue = (value) => {
  if (!value) return ''
  if (typeof value.format === 'function') return value.format('MM/DD/YYYY')
  return String(value)
}

function DateRange({ params, setParams }) {
  const [show, setShow] = useState(false)
  const target = useRef(null)

  const start = formatValue(params.startOn)
  const end = formatValue(params.endOn)
  const filterApplied = Boolean(start || end)

  const label = () => {
    if (start && end) return `${start} - ${end}`
    if (start) return `From ${start}`
    if (end) return `Until ${end}`
    return 'Date Range'
  }

  const datePattern =
    '(0?[1-9]|1[012])\\/(0?[1-9]|[12][0-9]|3[01])\\/\\d{4}'

  return (
    <>
      <Button
        ref={target}
        variant={filterApplied ? 'outline-primary' : ''}
        className={`w-100 text-start ${
          filterApplied ? 'bg-white text-primary' : 'bg-white text-info'
        }`}
        style={{ border: filterApplied ? '' : '1px solid #ced4da' }}
        onClick={() => setShow(!show)}
        data-testid="date-range-trigger"
      >
        {label()}
      </Button>
      <Overlay target={target.current} show={show} placement="bottom">
        <Popover style={{ minWidth: '380px' }}>
          <Popover.Header>
            <Row>
              <Col sm={6} className="d-grid">
                {filterApplied ? (
                  <Button
                    variant="link"
                    size="sm"
                    className="float-start mt-1"
                    onClick={() =>
                      setParams({ ...params, startOn: '', endOn: '' })
                    }
                  >
                    <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                    Clear
                  </Button>
                ) : null}
              </Col>
              <Col sm={6} className="d-grid">
                <Button
                  variant="primary"
                  size="sm"
                  className="float-end"
                  onClick={() => setShow(false)}
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </Popover.Header>
          <Popover.Body>
            <Row className="g-2">
              <Col>
                <label className="form-label small mb-1">Start Date</label>
                <Datetime
                  key={`start-${params.startOn}`}
                  inputProps={{
                    placeholder: 'Start Date',
                    pattern: datePattern,
                    className: 'form-control',
                    id: 'start-on'
                  }}
                  dateFormat="MM/DD/YYYY"
                  timeFormat={false}
                  onChange={(e) => setParams({ ...params, startOn: e })}
                  value={params.startOn || ''}
                />
              </Col>
              <Col>
                <label className="form-label small mb-1">End Date</label>
                <Datetime
                  key={`end-${params.endOn}`}
                  inputProps={{
                    placeholder: 'End Date',
                    pattern: datePattern,
                    className: 'form-control',
                    id: 'end-on'
                  }}
                  dateFormat="MM/DD/YYYY"
                  timeFormat={false}
                  onChange={(e) => setParams({ ...params, endOn: e })}
                  value={params.endOn || ''}
                />
              </Col>
            </Row>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  )
}

export default DateRange
